import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  FaArrowLeft,
  FaCheck,
  FaLink,
  FaRunning,
  FaTint,
  FaShieldAlt,
  FaCloudRain,
  FaDumbbell,
  FaFlask,
  FaTools,
  FaBox,
  FaCog,
  FaAward,
  FaUsers,
  FaGlobe,
  FaRulerCombined,
  FaPalette,
  FaStamp,
  FaTruck,
  FaIndustry,
  FaHome,
  FaHotel,
  FaBuilding,
  FaLeaf,
  FaStar
} from 'react-icons/fa';

/* ============================================================
   LOCAL IMAGE IMPORTS
   ============================================================ */

/* LOGO */
import kkMatsLogo from '../logos/kkmats/kkmatslogo.png';

/* 15 IMAGES */
import kkmat1 from '../logos/kkmats/kkmats1.png';
import kkmat2 from '../logos/kkmats/kkmats2.png';
import kkmat3 from '../logos/kkmats/kkmats3.png';
import kkmat4 from '../logos/kkmats/kkmats4.png';
import kkmat5 from '../logos/kkmats/kkmats5.png';
import kkmat6 from '../logos/kkmats/kkmats6.png';
import kkmat7 from '../logos/kkmats/kkmats7.png';
import kkmat8 from '../logos/kkmats/kkmats8.png';
import kkmat9 from '../logos/kkmats/kkmats9.png';
import kkmat10 from '../logos/kkmats/kkmats10.png';
import kkmat11 from '../logos/kkmats/kkmats11.png';
import kkmat12 from '../logos/kkmats/kkmats12.png';
import kkmat13 from '../logos/kkmats/kkmats13.png';
import kkmat14 from '../logos/kkmats/kkmats14.png';
import kkmat15 from '../logos/kkmats/kkmats15.png';
import kkmat16 from '../logos/kkmats/kkmat16.png';
import kkmat17 from '../logos/kkmats/kkmat17.png';
import kkmat18 from '../logos/kkmats/kkmat18.png';
import kkmat19 from '../logos/kkmats/kkmat19.png';
import kkmat20 from '../logos/kkmats/kkmat20.png';
import kkmat21 from '../logos/kkmats/kkmat21.png';


export default function KKMatsPage() {

  const navigate = useNavigate();

  return (
    <div style={styles.pageBackground}>

      {/* ======================================================
          RESPONSIVE + ANIMATION CSS
          ====================================================== */}

      <style>{`

        * {
          box-sizing: border-box;
        }

        html {
          scroll-behavior: smooth;
        }

        body {
          margin: 0;
          padding: 0;
          overflow-x: hidden;
        }

        @keyframes pageFade {
          from {
            opacity: 0;
            transform: translateY(25px);
          }

          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeUp {
          from {
            opacity: 0;
            transform: translateY(35px);
          }

          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeLeft {
          from {
            opacity: 0;
            transform: translateX(-35px);
          }

          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes fadeRight {
          from {
            opacity: 0;
            transform: translateX(35px);
          }

          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes floatImage {
          0%, 100% {
            transform: scale(1);
          }

          50% {
            transform: scale(1.025);
          }
        }

        @keyframes shimmer {
          0% {
            background-position: -500px 0;
          }

          100% {
            background-position: 500px 0;
          }
        }

        .kk-page {
          animation: pageFade 0.8s ease forwards;
        }

        .kk-header-left {
          animation: fadeLeft 0.9s ease forwards;
        }

        .kk-header-right {
          animation: fadeRight 1s ease forwards;
        }

        .kk-section {
          animation: fadeUp 0.8s ease forwards;
        }

        .kk-card {
          transition:
            transform 0.35s ease,
            box-shadow 0.35s ease,
            border-color 0.35s ease;
        }

        .kk-card:hover {
          transform: translateY(-7px);
          box-shadow: 0 14px 30px rgba(6, 78, 59, 0.18);
          border-color: #d4a72c !important;
        }

        .kk-image {
          transition:
            transform 0.55s ease,
            filter 0.4s ease;
        }

        .kk-card:hover .kk-image {
          transform: scale(1.08);
          filter: brightness(1.05);
        }

        .kk-product-card {
          transition:
            transform 0.3s ease,
            box-shadow 0.3s ease;
        }

        .kk-product-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(6, 78, 59, 0.16);
        }

        .kk-product-card img {
          transition: transform 0.5s ease;
        }

        .kk-product-card:hover img {
          transform: scale(1.08);
        }

        .kk-feature {
          transition:
            transform 0.3s ease,
            background-color 0.3s ease;
        }

        .kk-feature:hover {
          transform: translateY(-5px);
          background-color: #ecfdf5 !important;
        }

        .kk-pillar {
          transition:
            background-color 0.3s ease,
            transform 0.3s ease;
        }

        .kk-pillar:hover {
          background-color: rgba(255,255,255,0.08);
          transform: translateY(-3px);
        }

        .kk-back-button {
          transition:
            transform 0.3s ease,
            background-color 0.3s ease,
            box-shadow 0.3s ease;
        }

        .kk-back-button:hover {
          transform: translateX(-4px);
          background-color: #08644d !important;
          box-shadow: 0 8px 20px rgba(6,78,59,0.3);
        }

        .kk-logo {
          transition: transform 0.4s ease;
        }

        .kk-logo:hover {
          transform: scale(1.04);
        }

        .kk-app-card {
          transition:
            transform 0.35s ease,
            box-shadow 0.35s ease;
        }

        .kk-app-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 12px 25px rgba(0,0,0,0.35);
        }

        .kk-app-card img {
          transition: transform 0.5s ease;
        }

        .kk-app-card:hover img {
          transform: scale(1.1);
        }

        .kk-footer-item {
          transition: transform 0.3s ease;
        }

        .kk-footer-item:hover {
          transform: translateY(-4px);
        }


        /* ======================================================
           LARGE TABLET
           ====================================================== */

        @media (max-width: 1100px) {

          .kk-poster {
            padding: 22px !important;
          }

          .kk-header-grid {
            grid-template-columns: 1fr 1fr !important;
          }

          .kk-middle-grid {
            grid-template-columns: 1.5fr 1fr !important;
          }

          .kk-applications-grid {
            grid-template-columns: repeat(3, 1fr) !important;
          }

          .kk-footer {
            flex-wrap: wrap !important;
            gap: 20px !important;
          }

          .kk-footer-pillars {
            width: 100% !important;
            justify-content: space-between !important;
          }
        }


        /* ======================================================
           TABLET
           ====================================================== */

        @media (max-width: 850px) {

          .kk-page-bg {
            padding: 12px !important;
          }

          .kk-poster {
            padding: 18px !important;
          }

          .kk-header-grid {
            grid-template-columns: 1fr !important;
          }

          .kk-header-left {
            text-align: center;
          }

          .kk-main-title {
            align-items: center !important;
          }

          .kk-hero-heading {
            font-size: 32px !important;
          }

          .kk-header-right {
            min-height: 300px;
          }

          .kk-hero-image-container {
            height: 300px !important;
          }

          .kk-middle-grid {
            grid-template-columns: 1fr !important;
          }

          .kk-product-categories {
            grid-template-columns: 1fr 1fr !important;
          }

          .kk-lower-info {
            grid-template-columns: 1fr !important;
          }

          .kk-pillars {
            grid-template-columns: repeat(2, 1fr) !important;
          }

          .kk-applications-grid {
            grid-template-columns: repeat(3, 1fr) !important;
          }

          .kk-footer {
            flex-direction: column !important;
            text-align: center !important;
          }

          .kk-footer-company {
            align-items: center !important;
          }

          .kk-footer-pillars {
            justify-content: center !important;
            flex-wrap: wrap !important;
          }
        }


        /* ======================================================
           MOBILE
           ====================================================== */

        @media (max-width: 600px) {

          .kk-page-bg {
            padding: 0 !important;
          }

          .kk-top-nav {
            padding: 12px !important;
            margin: 0 !important;
          }

          .kk-back-button {
            width: 100%;
            justify-content: center;
          }

          .kk-poster {
            width: 100% !important;
            border-radius: 0 !important;
            padding: 14px !important;
            border-left: none !important;
            border-right: none !important;
          }

          .kk-logo {
            max-width: 230px !important;
          }

          .kk-hero-heading {
            font-size: 27px !important;
          }

          .kk-hero-desc {
            font-size: 12px !important;
          }

          .kk-hero-image-container {
            height: 230px !important;
          }

          .kk-quality-badge {
            width: 100% !important;
            justify-content: center !important;
            text-align: center !important;
            font-size: 9px !important;
          }

          .kk-pillars {
            grid-template-columns: 1fr 1fr !important;
            padding: 12px !important;
          }

          .kk-pillar {
            min-height: 85px !important;
            justify-content: center !important;
          }

          .kk-pillar-icon {
            font-size: 18px !important;
          }

          .kk-pillar-text {
            font-size: 8px !important;
          }

          .kk-product-categories {
            grid-template-columns: 1fr !important;
          }

          .kk-product-grid {
            grid-template-columns: 1fr 1fr !important;
          }

          .kk-prod-image {
            height: 105px !important;
          }

          .kk-prod-name {
            font-size: 8px !important;
          }

          .kk-features-grid {
            grid-template-columns: 1fr 1fr !important;
          }

          .kk-process-grid {
            grid-template-columns: 1fr 1fr !important;
          }

          .kk-process-image {
            height: 75px !important;
          }

          .kk-sidebar-box {
            padding: 14px !important;
          }

          .kk-applications-grid {
            grid-template-columns: 1fr 1fr !important;
          }

          .kk-app-card {
            height: 120px !important;
          }

          .kk-app-label {
            font-size: 8px !important;
          }

          .kk-footer {
            padding-bottom: 10px !important;
          }

          .kk-footer-badge {
            font-size: 30px !important;
          }

          .kk-footer-company-name {
            font-size: 12px !important;
          }

          .kk-footer-pillars {
            display: grid !important;
            grid-template-columns: 1fr 1fr !important;
            width: 100% !important;
            gap: 18px !important;
          }
        }


        /* ======================================================
           SMALL MOBILE
           ====================================================== */

        @media (max-width: 400px) {

          .kk-poster {
            padding: 10px !important;
          }

          .kk-hero-heading {
            font-size: 23px !important;
          }

          .kk-product-grid {
            grid-template-columns: 1fr !important;
          }

          .kk-features-grid {
            grid-template-columns: 1fr !important;
          }

          .kk-process-grid {
            grid-template-columns: 1fr !important;
          }

          .kk-applications-grid {
            grid-template-columns: 1fr !important;
          }

          .kk-pillars {
            grid-template-columns: 1fr !important;
          }

          .kk-footer-pillars {
            grid-template-columns: 1fr !important;
          }
        }

      `}</style>


      {/* ======================================================
          TOP NAVIGATION
          ====================================================== */}

      <div
        className="kk-top-nav"
        style={styles.topNav}
      >

        <button
          className="kk-back-button"
          style={styles.backButton}
          onClick={() => navigate('/')}
        >
          <FaArrowLeft
            style={{ marginRight: '8px' }}
          />

          Back to All Sectors
        </button>

      </div>


      {/* ======================================================
          MAIN PAGE
          ====================================================== */}

      <main
        className="kk-page kk-poster"
        style={styles.posterCard}
      >


        {/* ====================================================
            HEADER
            ==================================================== */}

        <section
          className="kk-header-grid"
          style={styles.headerGrid}
        >

          {/* LEFT */}

          <div
            className="kk-header-left"
            style={styles.headerLeft}
          >

            <div
              className="kk-main-title"
              style={styles.mainTitleBox}
            >

              <img
                className="kk-logo"
                src={kkMatsLogo}
                alt="KK Mats"
                style={styles.logo}
              />

            </div>


            <div style={styles.heroTextBox}>

              <h1
                className="kk-hero-heading"
                style={styles.heroHeading}
              >
                STRONG MATS.
                <br />
                <span style={styles.heroGold}>
                  SAFER SPACES.
                </span>
              </h1>


              <p
                className="kk-hero-desc"
                style={styles.heroDesc}
              >
                KK Mats is the Group’s dedicated PVC &amp; Rubber
                Mats manufacturing division, producing high quality
                mats for homes, commercial spaces, industries,
                and outdoor use.
              </p>


              <p
                className="kk-hero-desc"
                style={styles.heroDesc}
              >
                Built with premium raw materials and advanced
                technology, our mats deliver durability, safety,
                and performance in every step.
              </p>

            </div>

          </div>


          {/* RIGHT */}

          <div
            className="kk-header-right"
            style={styles.headerRight}
          >

            <div
              className="kk-quality-badge"
              style={styles.topQualityBadge}
            >

              <FaShieldAlt
                style={{
                  color: '#fbbf24',
                  fontSize: '16px'
                }}
              />

              <span>
                QUALITY YOU CAN TRUST,
                <br className="mobileBreak" />
                PERFORMANCE YOU CAN FEEL.
              </span>

            </div>


            <div
              className="kk-hero-image-container"
              style={styles.heroImageContainer}
            >

              <img
                className="kk-image"
                src={kkmat1}
                alt="KK Mats Main Product"
                style={styles.heroImg}
              />

            </div>

          </div>

        </section>


        {/* ====================================================
            FOUR PILLARS
            ==================================================== */}

        <section
          className="kk-pillars kk-section"
          style={styles.pillarsBar}
        >

          <div
            className="kk-pillar"
            style={styles.pillarItem}
          >
            <FaLink
              className="kk-pillar-icon"
              style={styles.pillarIcon}
            />

            <span
              className="kk-pillar-text"
              style={styles.pillarText}
            >
              DURABLE &amp;
              <br />
              LONG LASTING
            </span>
          </div>


          <div
            className="kk-pillar"
            style={styles.pillarItem}
          >
            <FaRunning
              className="kk-pillar-icon"
              style={styles.pillarIcon}
            />

            <span
              className="kk-pillar-text"
              style={styles.pillarText}
            >
              ANTI SLIP
              <br />
              SAFETY
            </span>
          </div>


          <div
            className="kk-pillar"
            style={styles.pillarItem}
          >
            <FaTint
              className="kk-pillar-icon"
              style={styles.pillarIcon}
            />

            <span
              className="kk-pillar-text"
              style={styles.pillarText}
            >
              EASY TO CLEAN
              <br />
              &amp; MAINTAIN
            </span>
          </div>


          <div
            className="kk-pillar"
            style={styles.pillarItem}
          >
            <FaShieldAlt
              className="kk-pillar-icon"
              style={styles.pillarIcon}
            />

            <span
              className="kk-pillar-text"
              style={styles.pillarText}
            >
              PREMIUM QUALITY
              <br />
              MATERIALS
            </span>
          </div>

        </section>


        {/* ====================================================
            MAIN CONTENT
            ==================================================== */}

        <section
          className="kk-middle-grid kk-section"
          style={styles.middleSectionGrid}
        >


          {/* ==================================================
              MAIN LEFT CONTENT
              ================================================== */}

          <div style={styles.middleMainCol}>


            {/* PRODUCT RANGE */}

            <div style={styles.sectionHeadingBar}>
              OUR PRODUCT RANGE
            </div>


            <div
              className="kk-product-categories"
              style={styles.productCategoriesContainer}
            >


              {/* PVC */}

              <div
                className="kk-card"
                style={styles.catBox}
              >

                <div style={styles.catTitle}>
                  PVC MATS
                </div>


                <div
                  className="kk-product-grid"
                  style={styles.productGrid4}
                >

                  <ProductCard
                    image={kkmat2}
                    name="PVC COIL MATS"
                  />

                  <ProductCard
                    image={kkmat3}
                    name="PVC SPAGHETTI MATS"
                  />

                  <ProductCard
                    image={kkmat4}
                    name="PVC LOOP MATS"
                  />

                  <ProductCard
                    image={kkmat5}
                    name="PVC DOOR MATS"
                  />

                </div>

              </div>


              {/* RUBBER */}

              <div
                className="kk-card"
                style={styles.catBox}
              >

                <div style={styles.catTitle}>
                  RUBBER MATS
                </div>


                <div
                  className="kk-product-grid"
                  style={styles.productGrid4}
                >

                  <ProductCard
                    image={kkmat6}
                    name="RUBBER RING MATS"
                  />

                  <ProductCard
                    image={kkmat7}
                    name="RUBBER HONEYCOMB MATS"
                  />

                  <ProductCard
                    image={kkmat8}
                    name="RUBBER STUDDED MATS"
                  />

                  <ProductCard
                    image={kkmat9}
                    name="RUBBER RIDGE MATS"
                  />

                </div>

              </div>

            </div>


            {/* =================================================
                FEATURES + PROCESS
                ================================================= */}

            <div
              className="kk-lower-info"
              style={styles.lowerInfoGrid}
            >


              {/* FEATURES */}

              <div
                className="kk-card"
                style={styles.featuresBox}
              >

                <div style={styles.subHeadingBar}>
                  — KEY FEATURES —
                </div>


                <div
                  className="kk-features-grid"
                  style={styles.featuresGrid}
                >

                  <Feature
                    icon={<FaRunning />}
                    text="ANTI SLIP SURFACE"
                  />

                  <Feature
                    icon={<FaCloudRain />}
                    text="WEATHER RESISTANT"
                  />

                  <Feature
                    icon={<FaDumbbell />}
                    text="HEAVY DUTY PERFORMANCE"
                  />

                  <Feature
                    icon={<FaFlask />}
                    text="CHEMICAL RESISTANT"
                  />

                  <Feature
                    icon={<FaTools />}
                    text="EASY TO CLEAN & MAINTAIN"
                  />

                  <Feature
                    icon={<FaShieldAlt />}
                    text="LONG LASTING & DURABLE"
                  />

                </div>

              </div>


              {/* MANUFACTURING PROCESS */}

              <div
                className="kk-card"
                style={styles.processBox}
              >

                <div style={styles.subHeadingBar}>
                  OUR MANUFACTURING PROCESS
                </div>


                <div
                  className="kk-process-grid"
                  style={styles.processStepsGrid}
                >

                  <Process
                    image={kkmat16}
                    text="RAW MATERIAL SELECTION"
                  />

                  <Process
                    image={kkmat17}
                    text="ADVANCED EXTRUSION"
                  />

                  <Process
                    image={kkmat18}
                    text="PRECISION MOLDING"
                  />

                  <Process
                    image={kkmat19}
                    text="QUALITY INSPECTION"
                  />

                  <Process
                    image={kkmat20}
                    text="CUTTING & FINISHING"
                  />

                  <Process
                    image={kkmat21}
                    text="PACKING & DISPATCH"
                  />

                </div>

              </div>

            </div>

          </div>


          {/* ==================================================
              RIGHT SIDEBAR
              ================================================== */}

          <aside
            style={styles.rightSidebarCol}
          >


            {/* CUSTOM SOLUTIONS */}

            <div
              className="kk-card kk-sidebar-box"
              style={styles.sidebarBox}
            >

              <div style={styles.sidebarTitle}>
                CUSTOM SOLUTIONS
              </div>


              <div style={styles.customList}>

                <CustomItem
                  icon={<FaRulerCombined />}
                  text="Multiple Sizes & Thicknesses"
                />

                <CustomItem
                  icon={<FaPalette />}
                  text="Custom Colors & Designs"
                />

                <CustomItem
                  icon={<FaStamp />}
                  text="Logo & Branding Options"
                />

                <CustomItem
                  icon={<FaBox />}
                  text="Bulk Orders Welcome"
                />

              </div>

            </div>


            {/* MADE IN PAKISTAN */}

            <div style={styles.exportBadgeBox}>

              <div style={styles.exportHeader}>

                <span>
                  MADE IN PAKISTAN
                </span>

                <span
                  style={{
                    fontSize: '25px'
                  }}
                >
                  🇵🇰
                </span>

              </div>


              <div style={styles.exportSub}>
                EXPORT QUALITY
              </div>


              <p style={styles.exportLocationText}>
                PROUDLY MANUFACTURING
                <br />
                FROM GUJRANWALA
              </p>

            </div>


            {/* WHY CHOOSE */}

            <div
              className="kk-card kk-sidebar-box"
              style={styles.sidebarBox}
            >

              <div style={styles.sidebarTitle}>
                WHY CHOOSE KK MATS?
              </div>


              <div style={styles.whyList}>

                <WhyItem text="High Quality Raw Materials" />

                <WhyItem text="Advanced Production Technology" />

                <WhyItem text="Strict Quality Control" />

                <WhyItem text="Competitive Prices" />

                <WhyItem text="On Time Delivery" />

                <WhyItem text="Excellent Customer Support" />

              </div>

            </div>


          </aside>

        </section>


        {/* ====================================================
            WIDE APPLICATIONS
            ==================================================== */}

        <section
          className="kk-applications kk-section"
          style={styles.applicationsSection}
        >

          <div style={styles.appSectionTitle}>
            WIDE APPLICATIONS
          </div>


          <div
            className="kk-applications-grid"
            style={styles.applicationsGrid}
          >

            <Application
              image={kkmat2}
              icon={<FaHome />}
              text="HOMES"
            />

            <Application
              image={kkmat3}
              icon={<FaBuilding />}
              text="OFFICES"
            />

            <Application
              image={kkmat4}
              icon={<FaHotel />}
              text="HOTELS"
            />

            <Application
              image={kkmat5}
              icon={<FaIndustry />}
              text="INDUSTRIES"
            />

            <Application
              image={kkmat6}
              icon={<FaBuilding />}
              text="COMMERCIAL SPACES"
            />

            <Application
              image={kkmat7}
              icon={<FaLeaf />}
              text="OUTDOOR USE"
            />

          </div>

        </section>


        {/* ====================================================
            FOOTER TAGLINE
            ==================================================== */}

        <div style={styles.footerTagline}>
          STRONG MATS. SAFER SPACES. TRUSTED QUALITY.
        </div>


        {/* ====================================================
            FOOTER
            ==================================================== */}

        <footer
          className="kk-footer"
          style={styles.footer}
        >


          {/* NUMBER */}

          <div
            className="kk-footer-badge"
            style={styles.footerBadge}
          >
            15
          </div>


          {/* COMPANY */}

          <div
            className="kk-footer-company"
            style={styles.footerCompanyInfo}
          >

            <strong
              className="kk-footer-company-name"
              style={styles.footerCompanyName}
            >
              ASHRAF GROUP OF INDUSTRIES
            </strong>

            <span style={styles.footerCompanyTagline}>
              Building Legacy. Powering the Future.
            </span>

          </div>


          {/* FOOTER PILLARS */}

          <div
            className="kk-footer-pillars"
            style={styles.footerPillarsRow}
          >

            <FooterItem
              icon={<FaCog />}
              text="ADVANCED MANUFACTURING FACILITY"
            />

            <FooterItem
              icon={<FaAward />}
              text="QUALITY ASSURED"
            />

            <FooterItem
              icon={<FaUsers />}
              text="CUSTOMER SATISFACTION"
            />

            <FooterItem
              icon={<FaGlobe />}
              text="DELIVERING WORLDWIDE"
            />

          </div>

        </footer>

      </main>

    </div>
  );
}


/* ============================================================
   PRODUCT CARD
   ============================================================ */

function ProductCard({ image, name }) {

  return (

    <div
      className="kk-product-card"
      style={styles.productCard}
    >

      <div style={styles.productImageWrapper}>

        <img
          src={image}
          alt={name}
          className="kk-prod-image"
          style={styles.prodImg}
        />

      </div>

      <span
        className="kk-prod-name"
        style={styles.prodName}
      >
        {name}
      </span>

    </div>

  );
}


/* ============================================================
   FEATURE
   ============================================================ */

function Feature({ icon, text }) {

  return (

    <div
      className="kk-feature"
      style={styles.featureItem}
    >

      <div style={styles.featureIcon}>
        {icon}
      </div>

      <span style={styles.featureText}>
        {text}
      </span>

    </div>

  );

}


/* ============================================================
   PROCESS
   ============================================================ */

function Process({ image, text }) {

  return (

    <div style={styles.processStep}>

      <div style={styles.processImageWrapper}>

        <img
          src={image}
          alt={text}
          className="kk-process-image"
          style={styles.processImg}
        />

      </div>

      <span style={styles.processLabel}>
        {text}
      </span>

    </div>

  );

}


/* ============================================================
   CUSTOM ITEM
   ============================================================ */

function CustomItem({ icon, text }) {

  return (

    <div style={styles.customItem}>

      <div style={styles.customIcon}>
        {icon}
      </div>

      <span>
        {text}
      </span>

    </div>

  );

}


/* ============================================================
   WHY ITEM
   ============================================================ */

function WhyItem({ text }) {

  return (

    <div style={styles.whyItem}>

      <FaCheck style={styles.whyCheck} />

      <span>
        {text}
      </span>

    </div>

  );

}


/* ============================================================
   APPLICATION
   ============================================================ */

function Application({ image, icon, text }) {

  return (

    <div
      className="kk-app-card"
      style={styles.appCard}
    >

      <img
        src={image}
        alt={text}
        style={styles.appImg}
      />

      <div
        className="kk-app-label"
        style={styles.appLabel}
      >

        <span style={styles.appIcon}>
          {icon}
        </span>

        {text}

      </div>

    </div>

  );

}


/* ============================================================
   FOOTER ITEM
   ============================================================ */

function FooterItem({ icon, text }) {

  return (

    <div
      className="kk-footer-item"
      style={styles.footerPillarItem}
    >

      <div style={styles.footerPillarIcon}>
        {icon}
      </div>

      <span>
        {text}
      </span>

    </div>

  );

}


/* ============================================================
   STYLES
   ============================================================ */

const styles = {

  /* PAGE */

  pageBackground: {
    backgroundColor: '#061a14',
    minHeight: '100vh',
    width: '100%',
    padding: '20px 20px 40px',
    fontFamily: '"Georgia", "Times New Roman", serif',
    color: '#1f2937'
  },


  /* TOP NAV */

  topNav: {
    width: '100%',
    maxWidth: '1500px',
    margin: '0 auto 16px'
  },


  backButton: {
    backgroundColor: '#064e3b',
    color: '#ffffff',
    border: '1px solid #d4a72c',
    padding: '11px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 'bold',
    fontSize: '13px',
    fontFamily: 'sans-serif'
  },


  /* POSTER */

  posterCard: {
    width: '100%',
    maxWidth: '1600px',
    margin: '0 auto',
    backgroundColor: '#fffdf5',
    boxShadow: '0 20px 60px rgba(0,0,0,0.45)',
    border: '1px solid #c89b3c',
    overflow: 'hidden',
    padding: '30px'
  },


  /* HEADER */

  headerGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1.15fr',
    gap: '35px',
    marginBottom: '25px',
    borderBottom: '1px solid #d4a72c',
    paddingBottom: '25px'
  },


  headerLeft: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },


  mainTitleBox: {
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'flex-start'
  },


  logo: {
    width: '300px',
    maxWidth: '100%',
    height: 'auto',
    objectFit: 'contain',
    display: 'block'
  },


  heroTextBox: {
    marginTop: '5px'
  },


  heroHeading: {
    margin: '0 0 16px',
    fontSize: '42px',
    fontWeight: '900',
    color: '#064e3b',
    lineHeight: '1.05',
    letterSpacing: '0.5px',
    fontFamily: '"Times New Roman", serif'
  },


  heroGold: {
    color: '#b8862c'
  },


  heroDesc: {
    margin: '0 0 12px',
    fontSize: '14px',
    color: '#374151',
    lineHeight: '1.7',
    fontFamily: 'Arial, sans-serif'
  },


  headerRight: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },


  topQualityBadge: {
    alignSelf: 'flex-end',
    backgroundColor: '#064e3b',
    color: '#ffffff',
    fontSize: '11px',
    fontWeight: 'bold',
    padding: '10px 18px',
    borderRadius: '5px',
    letterSpacing: '0.5px',
    display: 'flex',
    alignItems: 'center',
    gap: '9px',
    fontFamily: 'Arial, sans-serif',
    border: '1px solid #d4a72c',
    lineHeight: '1.35'
  },


  heroImageContainer: {
    width: '100%',
    height: '330px',
    borderRadius: '8px',
    overflow: 'hidden',
    border: '2px solid #d4a72c',
    backgroundColor: '#e5e7eb'
  },


  heroImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block'
  },


  /* PILLARS */

  pillarsBar: {
    backgroundColor: '#064e3b',
    borderRadius: '7px',
    padding: '18px 25px',
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '15px',
    marginBottom: '25px',
    border: '1px solid #d4a72c'
  },


  pillarItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
    color: '#ffffff',
    padding: '10px'
  },


  pillarIcon: {
    fontSize: '25px',
    color: '#e5b84b',
    flexShrink: 0
  },


  pillarText: {
    fontSize: '11px',
    fontWeight: 'bold',
    color: '#ffffff',
    letterSpacing: '0.7px',
    fontFamily: 'Arial, sans-serif',
    lineHeight: '1.4'
  },


  /* MAIN GRID */

  middleSectionGrid: {
    display: 'grid',
    gridTemplateColumns: '1.75fr 0.9fr',
    gap: '25px',
    marginBottom: '25px'
  },


  middleMainCol: {
    display: 'flex',
    flexDirection: 'column',
    gap: '18px'
  },


  sectionHeadingBar: {
    backgroundColor: '#064e3b',
    color: '#ffffff',
    textAlign: 'left',
    padding: '12px 18px',
    fontSize: '14px',
    fontWeight: 'bold',
    letterSpacing: '2px',
    borderRadius: '5px',
    fontFamily: 'Arial, sans-serif',
    borderLeft: '7px solid #d4a72c'
  },


  /* PRODUCTS */

  productCategoriesContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '18px'
  },


  catBox: {
    backgroundColor: '#ffffff',
    border: '1px solid #d8c98c',
    borderRadius: '7px',
    padding: '13px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },


  catTitle: {
    backgroundColor: '#c89b3c',
    color: '#ffffff',
    fontSize: '12px',
    fontWeight: 'bold',
    textAlign: 'center',
    padding: '7px',
    borderRadius: '3px',
    letterSpacing: '1px',
    fontFamily: 'Arial, sans-serif'
  },


  productGrid4: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '10px'
  },


  productCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#f8fafc',
    borderRadius: '5px',
    overflow: 'hidden',
    border: '1px solid #e5e7eb',
    paddingBottom: '7px'
  },


  productImageWrapper: {
    width: '100%',
    overflow: 'hidden',
    backgroundColor: '#e5e7eb'
  },


  prodImg: {
    width: '100%',
    height: '120px',
    objectFit: 'cover',
    display: 'block'
  },


  prodName: {
    fontSize: '9px',
    fontWeight: 'bold',
    color: '#0f172a',
    marginTop: '7px',
    textAlign: 'center',
    fontFamily: 'Arial, sans-serif',
    padding: '0 4px',
    lineHeight: '1.3'
  },


  /* LOWER */

  lowerInfoGrid: {
    display: 'grid',
    gridTemplateColumns: '0.9fr 1.3fr',
    gap: '18px'
  },


  featuresBox: {
    backgroundColor: '#ffffff',
    border: '1px solid #d8c98c',
    borderRadius: '7px',
    padding: '14px'
  },


  subHeadingBar: {
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#064e3b',
    textAlign: 'center',
    marginBottom: '12px',
    letterSpacing: '1px',
    fontFamily: 'Arial, sans-serif'
  },


  featuresGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '10px'
  },


  featureItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    backgroundColor: '#f8fafc',
    padding: '12px 7px',
    borderRadius: '5px',
    border: '1px solid #dbe5dc',
    minHeight: '95px',
    justifyContent: 'center'
  },


  featureIcon: {
    fontSize: '20px',
    color: '#064e3b',
    marginBottom: '7px'
  },


  featureText: {
    fontSize: '8px',
    fontWeight: 'bold',
    color: '#1e293b',
    fontFamily: 'Arial, sans-serif',
    lineHeight: '1.3'
  },


  /* PROCESS */

  processBox: {
    backgroundColor: '#ffffff',
    border: '1px solid #d8c98c',
    borderRadius: '7px',
    padding: '14px'
  },


  processStepsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '10px'
  },


  processStep: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#f8fafc',
    borderRadius: '5px',
    padding: '5px',
    border: '1px solid #e5e7eb',
    overflow: 'hidden'
  },


  processImageWrapper: {
    width: '100%',
    overflow: 'hidden',
    borderRadius: '3px'
  },


  processImg: {
    width: '100%',
    height: '85px',
    objectFit: 'cover',
    borderRadius: '3px',
    display: 'block'
  },


  processLabel: {
    fontSize: '7.5px',
    fontWeight: 'bold',
    color: '#0f172a',
    textAlign: 'center',
    fontFamily: 'Arial, sans-serif',
    lineHeight: '1.25',
    marginTop: '6px',
    minHeight: '20px'
  },


  /* SIDEBAR */

  rightSidebarCol: {
    display: 'flex',
    flexDirection: 'column',
    gap: '18px'
  },


  sidebarBox: {
    backgroundColor: '#ffffff',
    border: '1px solid #d8c98c',
    borderRadius: '7px',
    padding: '15px'
  },


  sidebarTitle: {
    backgroundColor: '#064e3b',
    color: '#e5b84b',
    fontSize: '12px',
    fontWeight: 'bold',
    textAlign: 'center',
    padding: '9px',
    borderRadius: '4px',
    letterSpacing: '1px',
    marginBottom: '13px',
    fontFamily: 'Arial, sans-serif'
  },


  customList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },


  customItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontSize: '10px',
    fontWeight: 'bold',
    color: '#1e293b',
    fontFamily: 'Arial, sans-serif',
    borderBottom: '1px solid #eef2f1',
    paddingBottom: '9px',
    lineHeight: '1.35'
  },


  customIcon: {
    color: '#064e3b',
    fontSize: '16px',
    flexShrink: 0
  },


  /* PAKISTAN */

  exportBadgeBox: {
    backgroundColor: '#064e3b',
    borderRadius: '7px',
    padding: '18px 12px',
    textAlign: 'center',
    color: '#ffffff',
    border: '1px solid #d4a72c'
  },


  exportHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    fontSize: '15px',
    fontWeight: '900',
    letterSpacing: '1px',
    fontFamily: 'Arial, sans-serif'
  },


  exportSub: {
    fontSize: '17px',
    fontWeight: '900',
    color: '#e5b84b',
    letterSpacing: '2px',
    margin: '7px 0',
    fontFamily: 'Arial, sans-serif'
  },


  exportLocationText: {
    margin: 0,
    fontSize: '9px',
    letterSpacing: '0.6px',
    color: '#d1d5db',
    fontFamily: 'Arial, sans-serif',
    fontWeight: 'bold',
    lineHeight: '1.5'
  },


  /* WHY */

  whyList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '9px'
  },


  whyItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '9px',
    fontSize: '10px',
    fontWeight: 'bold',
    color: '#1e293b',
    fontFamily: 'Arial, sans-serif',
    borderBottom: '1px solid #f1f5f9',
    paddingBottom: '8px',
    lineHeight: '1.35'
  },


  whyCheck: {
    color: '#059669',
    fontSize: '12px',
    flexShrink: 0
  },


  /* APPLICATIONS */

  applicationsSection: {
    backgroundColor: '#0b3026',
    borderRadius: '7px',
    padding: '18px',
    marginBottom: '20px',
    border: '1px solid #d4a72c'
  },


  appSectionTitle: {
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: '15px',
    letterSpacing: '2px',
    fontFamily: 'Arial, sans-serif'
  },


  applicationsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(6, 1fr)',
    gap: '12px'
  },


  appCard: {
    position: 'relative',
    height: '120px',
    borderRadius: '5px',
    overflow: 'hidden',
    border: '1px solid #d4a72c',
    backgroundColor: '#111827'
  },


  appImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block'
  },


  appLabel: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(6, 78, 59, 0.94)',
    color: '#ffffff',
    fontSize: '8px',
    fontWeight: 'bold',
    padding: '7px 3px',
    textAlign: 'center',
    fontFamily: 'Arial, sans-serif',
    letterSpacing: '0.5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '5px'
  },


  appIcon: {
    color: '#e5b84b',
    fontSize: '10px'
  },


  /* TAGLINE */

  footerTagline: {
    textAlign: 'center',
    color: '#064e3b',
    fontSize: '14px',
    fontWeight: 'bold',
    letterSpacing: '2px',
    padding: '12px 5px',
    marginBottom: '15px',
    fontFamily: 'Georgia, serif',
    borderTop: '1px solid #d4a72c',
    borderBottom: '1px solid #d4a72c'
  },


  /* FOOTER */

  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '25px',
    borderTop: '3px solid #064e3b',
    paddingTop: '15px'
  },


  footerBadge: {
    backgroundColor: '#064e3b',
    color: '#ffffff',
    fontSize: '34px',
    fontWeight: '900',
    padding: '4px 18px',
    borderRadius: '2px',
    fontFamily: 'Georgia, serif'
  },


  footerCompanyInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '3px'
  },


  footerCompanyName: {
    fontSize: '15px',
    color: '#064e3b',
    letterSpacing: '0.6px',
    fontWeight: 'bold',
    fontFamily: 'Arial, sans-serif'
  },


  footerCompanyTagline: {
    fontSize: '11px',
    color: '#a47722',
    fontStyle: 'italic',
    fontFamily: 'Georgia, serif'
  },


  footerPillarsRow: {
    display: 'flex',
    gap: '22px',
    alignItems: 'stretch'
  },


  footerPillarItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: '7.5px',
    fontWeight: 'bold',
    color: '#334155',
    lineHeight: '1.3',
    fontFamily: 'Arial, sans-serif',
    maxWidth: '110px'
  },


  footerPillarIcon: {
    fontSize: '20px',
    color: '#064e3b',
    marginBottom: '5px'
  }

};